/*  ========================================================================
    # Hooks - Use Contributors API
    ========================================================================  */

import { useEffect, useState } from 'react';

const useContributorsApi = params => {
  const [loadingContributors, setLoadingContributors] = useState(true);
  const [contributorsCount, setContributorsCount] = useState(0);
  const [contributors, setContributors] = useState([]);
  const paramsString = new URLSearchParams();

  const getContributors = async () => {
    setLoadingContributors(true);

    // Add ACF formatter to get images
    paramsString.append('acf_format', 'standard');

    for (const [key, value] of Object.entries(params)) {
      paramsString.append(key, value);
    }

    try {
      const response = await fetch(`/wp-json/wp/v2/tk_contributor?${paramsString.toString()}`);

      if (response.status !== 200) {
        throw new Error(await response.text());
      }

      const contributors = await response.json();
      const mappedContributors = contributors.map(contributor => ({
        id: contributor.id,
        image: contributor.acf.image,
        title: contributor.title.rendered,
        name: contributor.acf.name,
        surname: contributor.acf.surname,
        position: contributor.acf.position,
        url: contributor.link
      }));

      setLoadingContributors(false);
      setContributorsCount(parseInt(response.headers.get('X-WP-Total'), 10));
      setContributors(mappedContributors);
    } catch (error) {
      setLoadingContributors(false);
      console.log(error); // eslint-disable-line
    }
  };

  useEffect(() => {
    getContributors();
  }, [params.per_page, params.page, params.categories, params.search]);

  return { loadingContributors, contributorsCount, contributors };
};

export default useContributorsApi;
